import React, { useCallback, useContext, useMemo } from "react";
import clsx from "clsx";

import { MAX_INPUT_LENGTH } from "../../Field/Field";
import IconButton from "../../../common/IconButton/IconButton";
import { IconClose, IconSearch } from "../../../../assets";
import {
	LocaleContext,
	TextElement,
	translate,
} from "../../../../lib/util/LocaleUtils";
import * as strings from "../../../../strings";
import { useTranslate } from "../../../../lib/hook/LocaleHooks";
import AsyncState from "react-async-stateful";

export interface SearchBarInputProps {
	onOpenChange?: (open: boolean) => void;
	placeholder?: TextElement;
	focusPlaceholder?: TextElement;
	onFilterItem?: any;
	hideIcon?: boolean;
	value?: string;
	searchIsActive?: boolean;
	onChange?: (e: React.ChangeEvent) => void;
}

const SearchBarInput = (props: SearchBarInputProps) => {
	const {
		placeholder,
		value,
		searchIsActive,
		onChange,
		hideIcon,
		focusPlaceholder,
		onOpenChange,
	} = props;

	const handleClose = useCallback(() => {
		if (onOpenChange) {
			onOpenChange(false);
		}
	}, [onOpenChange]);

	const handleOpen = useCallback(() => {
		if (onOpenChange) {
			onOpenChange(true);
		}
	}, [onOpenChange]);

	const translate = useTranslate();

	const translatedPlaceholders = useMemo(
		() => ({
			focusPlaceholder: focusPlaceholder && translate(focusPlaceholder),
			placeholder: translate(placeholder || strings.DRIVERS_SEARCH_DRIVERS),
		}),
		[focusPlaceholder, placeholder, translate],
	);

	const handleFocus = useCallback(
		(e: any) => {
			if (translatedPlaceholders.focusPlaceholder) {
				e.currentTarget.placeholder = translatedPlaceholders.focusPlaceholder;
			}
		},
		[translatedPlaceholders.focusPlaceholder],
	);

	const handleBlur = useCallback(
		(e: any) => {
			if (translatedPlaceholders.focusPlaceholder) {
				e.currentTarget.placeholder = translatedPlaceholders.placeholder;
			}
		},
		[
			translatedPlaceholders.focusPlaceholder,
			translatedPlaceholders.placeholder,
		],
	);

	return (
		<div className={clsx("SearchBarInput", searchIsActive && "--visible")}>
			<input
				maxLength={MAX_INPUT_LENGTH}
				type={"text"}
				value={value}
				placeholder={translatedPlaceholders.placeholder}
				onFocus={handleFocus}
				onBlur={handleBlur}
				onChange={onChange}
			/>

			{!hideIcon && (
				<IconSearch
					onClick={handleOpen}
					className={clsx("navigation-search", searchIsActive && "--visible")}
				/>
			)}

			<IconButton
				onClick={handleClose}
				className={clsx("navigation-close", searchIsActive && "--visible")}
			>
				<IconClose />
			</IconButton>
		</div>
	);
};

export default SearchBarInput;
